import {Form} from 'react-bootstrap';
import {ControlledInput} from '../../interfaces/Forms';

interface SwitchInputControlledProps {
    value: string;
    defaultValue?: boolean;
}
const SwitchInputControlled = ({
    id,
    name,
    label,
    value,
    onChange,
    onBlur,
    onReset,
    touched,
    errors,
    defaultValue,
}: ControlledInput & SwitchInputControlledProps): JSX.Element => {
    return (
        <Form.Group>
            <Form.Switch
                id={id ?? name + '_' + value}
                className="mb-2 fw-bold fs-3 required"
                name={name}
                label={label}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onReset={onReset}
                defaultChecked={defaultValue}
            ></Form.Switch>
            {touched && errors && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">{errors}</span>
                    </div>
                </div>
            )}
        </Form.Group>
    );
};

export default SwitchInputControlled;
